import { useAddToListButton } from "@/hooks/Wishlist/AddToListButton/useAddToListButton"
import clsx from "clsx"
import { useRef } from "react"
import { useButton } from "react-aria"
import { useCommonToasts } from "./useCommonToasts"

const AddToListButton = (props) => {
  const talonProps = useAddToListButton(props)
  const buttonRef = useRef()
  const { classes = {} } = props

  const {
    buttonProps,
    buttonText,
    errorToastProps,
    loginToastProps,
    successToastProps,
    isSelected,
  } = talonProps

  useCommonToasts({
    errorToastProps,
    loginToastProps,
    successToastProps,
  })
  const { buttonProps: ariaButtonProps } = useButton(buttonProps, buttonRef)

  return (
    <button
      ref={buttonRef}
      className={clsx(isSelected ? classes.root_selected : classes.root)}
      {...ariaButtonProps}
    >
      {buttonText}
    </button>
  )
}

export default AddToListButton
